import { useEffect, useState } from 'react';
import { Popover } from 'antd';

const ContextPopover = ({
  anchor,
  content,
  onHandleClose,
  placement = 'bottomRight',
}) => {
  const open = Boolean(anchor); // Open popover only when anchor (clicked element) exists

  const [, setViewportTick] = useState(0);

  const anchorPosition = anchor?.getBoundingClientRect(); // Get position of anchor element

  const getAnchorStyle = () => ({
    top: `${anchorPosition?.bottom ?? 0}px`, // Position popover below anchor
    left: `${anchorPosition?.right ?? 0}px`, // Align popover to the right of anchor
  });

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : ''; // Lock/unlock page scroll based on popover state
    const updatePosition = () => setViewportTick((prev) => prev + 1); // Trigger re-render to recalculate position
    window.addEventListener('resize', updatePosition); // Update position when screen resizes
    return () => window.removeEventListener('resize', updatePosition); // Cleanup resize listener
  }, [open]);

  if (!open) return null;

  const handleOpenChange = (nextOpen) => {
    if (!nextOpen) {
      onHandleClose();
    }
  };

  return (
    <>
      <Popover
        open={open}
        content={content}
        trigger='click'
        placement={placement}
        overlayClassName='gne-context'
        onOpenChange={handleOpenChange}
        arrow={false}>
        <span
          className='gne-context-anchor'
          style={getAnchorStyle()}
        />
      </Popover>
    </>
  );
};

export default ContextPopover;
